import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="bg-primary-dark text-text-dark py-20 md:py-32 relative overflow-hidden" data-id="element-190">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#c9953e 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-191"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-192">
        <FadeIn data-id="element-193">
          <div className="text-center mb-12" data-id="element-194">
            <h2 className="text-sm font-sans uppercase tracking-widest text-accent font-bold mb-4" data-id="element-195">
              La Solución
            </h2>
            <h3 className="text-3xl md:text-5xl font-bold leading-tight" data-id="element-196">
              El Método de la{' '}
              <span className="text-accent border-b-2 border-accent/30 pb-1" data-id="element-197">
                Piedra Gris
              </span>{' '}
              y el{' '}
              <span className="text-accent border-b-2 border-accent/30 pb-1" data-id="element-198">
                Desapego Táctico
              </span>
              .
            </h3>
          </div>
        </FadeIn>

        <div className="bg-secondary-dark/60 border border-accent/20 rounded-2xl p-8 md:p-12 backdrop-blur-sm relative" data-id="element-199">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-primary-dark border border-accent/30 p-3 rounded-full text-accent" data-id="element-200">
            <ShieldCheck size={32} data-id="element-201" />
          </div>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-text-muted mt-4" data-id="element-202">
            <FadeIn delay={0.2} data-id="element-203">
              <p data-id="element-204">
                No vamos a intentar que ames un lugar difícil. Vamos a
                convertirte en alguien{' '}
                <strong className="text-white" data-id="element-205">emocionalmente invisible</strong>{' '}
                para el drama.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-206">
              <p data-id="element-207">
                Es una técnica de ingeniería de percepción que te permite
                cumplir con tu contrato{' '}
                <strong className="text-accent" data-id="element-208">sin entregar tu paz</strong>.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-209">
              <p className="font-serif text-2xl text-white italic text-center pt-6 border-t border-secondary-dark mt-8" data-id="element-210">
                "Aprendés a ver la oficina como un decorado y no como tu
                realidad total."
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}